export const SHIP_BUILDER_ACTION_TYPES = {
  // Step navigation
  SET_CURRENT_STEP: "shipBuilder/setCurrentStep",

  // Ship stats and details
  UPDATE_SHIP_STATS: "shipBuilder/updateShipStats",
  SET_SHIP_STATS: "shipBuilder/setStats",
  SET_SHIP_DETAILS: "shipBuilder/setShipDetails",
  SET_SHIP_NAME: "shipBuilder/setShipName",
  SET_SHIP_TYPE: "shipBuilder/setShipType",
  SET_SHIP_SIZE: "shipBuilder/setShipSize",
  SET_TECH_LEVEL: "shipBuilder/setTechLevel",

  // Core components
  SET_HULL: "shipBuilder/setHull",
  SET_DRIVES: "shipBuilder/setDrives",
  SET_POWER_PLANT: "shipBuilder/setPowerPlant",
  SET_BRIDGE: "shipBuilder/setBridge",
  SET_SENSORS: "shipBuilder/setSensors",
  SET_ARMOR: "shipBuilder/setArmor",
  SET_WEAPONS: "shipBuilder/setWeapons",
  SET_SOFTWARE: "shipBuilder/setSoftware",

  // Component selection
  SET_SELECTED_HULL: "shipBuilder/setSelectedHull",
  SET_SELECTED_DRIVES: "shipBuilder/setSelectedDrives",
  SET_SELECTED_POWER_PLANT: "shipBuilder/setSelectedPowerPlant",
  SET_SELECTED_BRIDGE: "shipBuilder/setSelectedBridge",
  SET_SELECTED_ARMOR: "shipBuilder/setSelectedArmor",
  SET_SELECTED_SENSORS: "shipBuilder/setSelectedSensors",
  SET_SELECTED_CARGO: "shipBuilder/setSelectedCargo",
  SET_SELECTED_FUEL: "shipBuilder/setSelectedFuel",
  SET_SELECTED_STATEROOMS: "shipBuilder/setSelectedStaterooms",
  SET_SELECTED_CREW: "shipBuilder/setSelectedCrew",
  SET_SELECTED_SOFTWARE: "shipBuilder/setSelectedSoftware",

  // Configuration
  SET_CARGO_SPACE: "shipBuilder/setCargoSpace",
  SET_FUEL_TANKS: "shipBuilder/setFuelTanks",
  SET_CREW_COMPOSITION: "shipBuilder/setCrewComposition",
  SET_STATEROOM_CONFIG: "shipBuilder/setStateroomConfig",
  SET_CARGO: "shipBuilder/setCargo",
  SET_FUEL: "shipBuilder/setFuel",
  SET_CREW: "shipBuilder/setCrew",
  SET_STATEROOMS: "shipBuilder/setStaterooms",
  SET_FEATURES: "shipBuilder/setFeatures",
  SET_OPTIONAL_SYSTEMS: "shipBuilder/setOptionalSystems",

  // Weapons and mounts
  ADD_WEAPON: "shipBuilder/addWeapon",
  REMOVE_WEAPON: "shipBuilder/removeWeapon",
  ADD_WEAPON_MOUNT: "shipBuilder/addWeaponMount",
  REMOVE_WEAPON_MOUNT: "shipBuilder/removeWeaponMount",
  SET_WEAPON_SELECTIONS: "shipBuilder/setWeaponSelections",
  SET_WEAPON_COUNTS: "shipBuilder/setWeaponCounts",

  // Additional configuration
  SET_SMALL_CRAFT_COUNT: "shipBuilder/setSmallCraftCount",
  SET_PASSENGER_COUNTS: "shipBuilder/setPassengerCounts",
  SET_VALIDATION_STATE: "shipBuilder/setValidationState",

  // Reset actions
  RESET_SHIP_BUILDER: "shipBuilder/reset",
  RESET_SHIP: "shipBuilder/resetShip",

  // Final details
  SET_FINAL_DETAILS: "shipBuilder/setFinalDetails",

  // Ship Builder Actions
  SET_HULL_SELECTION: "shipBuilder/setHullSelection",
  SET_ARMOR_SELECTION: "shipBuilder/setArmorSelection",
  SET_DRIVE_SELECTION: "shipBuilder/setDriveSelection",
  SET_POWER_PLANT_SELECTION: "shipBuilder/setPowerPlantSelection",
  SET_BRIDGE_SELECTION: "shipBuilder/setBridgeSelection",
  SET_COMPUTER_SELECTION: "shipBuilder/setComputerSelection",
  SET_SOFTWARE_SELECTION: "shipBuilder/setSoftwareSelection",
  SET_OPTIONAL_SYSTEMS_SELECTION: "shipBuilder/setOptionalSystemsSelection",
  SET_CREW_SELECTION: "shipBuilder/setCrewSelection",
  SET_STATEROOM_SELECTION: "shipBuilder/setStateroomSelection",
  SET_FINAL_DETAILS_SELECTION: "shipBuilder/setFinalDetailsSelection",
  SET_FUEL_SELECTION: "shipBuilder/setFuelSelection",
  SET_CARGO_SELECTION: "shipBuilder/setCargoSelection",
  SET_WEAPONS_SELECTION: "shipBuilder/setWeaponsSelection",

  // Software Actions
  INSTALL_SOFTWARE: "shipBuilder/installSoftware",
  UNINSTALL_SOFTWARE: "shipBuilder/uninstallSoftware",
  SET_SOFTWARE_LEVEL: "shipBuilder/setSoftwareLevel",
  START_SOFTWARE: "shipBuilder/startSoftware",
  STOP_SOFTWARE: "shipBuilder/stopSoftware",
} as const;

// Type for action types
export type ShipBuilderActionType =
  (typeof SHIP_BUILDER_ACTION_TYPES)[keyof typeof SHIP_BUILDER_ACTION_TYPES];
